/* eslint-disable camelcase */
export var MarketingPrices;
(function (MarketingPrices) {
  MarketingPrices["exp_dp"] = "exp_dp";
  MarketingPrices["exp_tx"] = "exp_tx";
  MarketingPrices["trv_dp"] = "trv_dp";
  MarketingPrices["trv_bp"] = "trv_bp";
})(MarketingPrices || (MarketingPrices = {}));